<div style="background: white;">
  <section class="bg-size">
    <div class="block no-padding">
      <div class="container-fluid">
        <ng-container *ngIf="!type">
          <div class="row" *ngIf="offer_details">
            <div class="col-md-12 mt-3" style="margin-bottom: 30px;">
              <div class="px-md-4 pt-2">
                <h6 class="card-title job-description1 m-0 mb-3 p-0" *ngIf="!disable_action">
                  {{offer_details.headerText}}
                </h6>
                <div class="pt-2">
                  <div class="row">
                    <div class="col-md-8 col-12 text-center" style="min-height: 550px;">
                      <ng-container *ngIf="signed_url">

                        <app-ngx-dov-viewer viewer="google" [cdnPath]="signed_url"
                          style="width: 100%;height: 100%;min-height: 400px; object-fit: contain;">
                        </app-ngx-dov-viewer>

                        <!-- <object id="resumeViewer" frameborder="0" style="width: 100%;height: 100%;"
                          [data]="offer_details.fileData | SafeFilePipe" *ngIf="reset_embed_tag">

                        </object> -->
                      </ng-container>
                      <!-- <ng-container *ngIf="loading"><i class="fa fa-spinner fa-spin"></i> Loading </ng-container> -->


                    </div>
                    <div class="col-md-4 col-12">
                      <div class="card-box-shadow">
                        <!-- <div class="offer-info-header">
                          Offer Information
                        </div>
                        <div class="px-4 py-3">
                          <div class="mb-1 offer-info" *ngIf="offer_details && offer_details.designationTitle">
                            <span class="offer-info-title">
                              Designation
                            </span>
                            <span class="offer-info-details" [title]="offer_details.designationTitle">
                              {{offer_details.designationTitle}}
                            </span>
                          </div>
                          <div class="mb-1 offer-info" *ngIf="offer_details && offer_details.location">
                            <span class="offer-info-title">
                              Location
                            </span>
                            <span class="offer-info-details" [title]="offer_details.location">
                              {{offer_details.location}}
                            </span>
                          </div>
                          <div class="mb-1 offer-info" *ngIf="offer_details && offer_details.grade">
                            <span class="offer-info-title">
                              Grade
                            </span>
                            <span class="offer-info-details" [title]="offer_details.grade">
                              {{offer_details.grade}}
                            </span>
                          </div>
                          <div class="mb-1 offer-info"
                            *ngIf="offer_details && offer_details.noticePeriod && offer_details.noticePeriod != '0'">
                            <span class="offer-info-title">
                              Notice Period
                            </span>
                            <span class="offer-info-details" [title]="offer_details.noticePeriod">
                              {{offer_details.noticePeriod}} days
                            </span>
                          </div>
                          <div class="mb-1 offer-info" *ngIf="offer_details && offer_details.plannedJoiningDt">
                            <span class="offer-info-title">
                              Planned date of joining
                            </span>
                            <span class="offer-info-details" [title]="offer_details.plannedJoiningDt">
                              {{offer_details.plannedJoiningDt | UtcToLocalTime | date: 'dd-MMM-yyyy'}}
                            </span>
                          </div>
                          <div class="mb-1 offer-info"
                            *ngIf="offer_details && offer_details.offeredCTC && offer_details.offeredCTC != '  '">
                            <span class="offer-info-title">
                              Offered Salary
                            </span>
                            <span class="offer-info-details" [title]="offer_details.offeredCTC">
                              {{offer_details.offeredCTCCurrencyTitle}}
                              {{offer_details.offeredCTC}}
                              {{offer_details.offeredCTCDurationTitle}}
                            </span>
                          </div>
                          <div class="mb-1 offer-info"
                            *ngIf="offer_details && offer_details.offered_datetime && offer_details.offered_datetime != '  '">
                            <span class="offer-info-title">
                              Offered on
                            </span>
                            <span class="offer-info-details" [title]="offer_details.offered_datetime">
                              {{offer_details.offered_datetime | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'}}
                            </span>
                          </div>
                        </div> -->
                        <div class="header text-center">
                          Offer Information
                        </div>
                        <table cellspacing="0" class="table">

                          <td>
                            <tr *ngIf="offer_details && offer_details.designationTitle">
                              <th>Designation </th>
                              <td>{{offer_details.designationTitle}}</td>
                            </tr>
                            <tr *ngIf="offer_details && offer_details.location">
                              <th>Job Location </th>
                              <td>{{offer_details.location}}</td>
                            </tr>
                            <tr *ngIf="offer_details && offer_details.grade">
                              <th> Grade</th>
                              <td>{{offer_details.grade}}</td>
                            </tr>
                            <tr
                              *ngIf="offer_details && offer_details.noticePeriod && offer_details.noticePeriod != '0'">
                              <th>Notice Period </th>
                              <td> {{offer_details.noticePeriod}} days</td>
                            </tr>
                            <tr *ngIf="offer_details && offer_details.plannedJoiningDt">
                              <th>Planned date of joining </th>
                              <td> {{offer_details.plannedJoiningDt | UtcToLocalTime | date: 'dd-MMM-yyyy'}}</td>
                            </tr>
                            <tr *ngIf="offer_details && offer_details.offeredCTC && offer_details.offeredCTC != '  '">
                              <th>Offered Salary</th>
                              <td>
                                {{offer_details.offeredCTCCurrencyTitle}}
                                {{offer_details.offeredCTC}}
                                {{offer_details.offeredCTCDurationTitle}}
                              </td>
                            </tr>
                            <tr *ngIf="offer_details && offer_details.offered_datetime">
                              <th>Offered on </th>
                              <td> {{offer_details.offered_datetime | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'}}
                              </td>
                            </tr>

                            <tr *ngIf="offer_details && offer_details.candidateJoiningDate">
                              <th>Joining date </th>
                              <td> {{offer_details.candidateJoiningDate
                                | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'}}
                              </td>
                            </tr>

                            <tr>
                              <th>IP </th>
                              <td *ngIf="offer_details && offer_details.offerIP"> {{offer_details.offerIP}}</td>
                              <td *ngIf="!(offer_details && offer_details.offerIP)"> {{getLocalIPAddress}}</td>
                            </tr>
                          </td>
                        </table>


                        <div class="px-2"
                          *ngIf="field_config_access && field_config_access['CAREERS_candidateJoiningDate'] && !(offer_details && offer_details.candidateJoiningDate)">
                          <tm-date-picker
                            [placeholder]="field_config_access['CAREERS_candidateJoiningDate'] && field_config_access['CAREERS_candidateJoiningDate'].placeholder||  'Select Joining Date' | translate "
                            [form]="digital_signature_form" [controlName]="'candidateJoiningDate'"
                            [label]="field_config_access['CAREERS_candidateJoiningDate'] && field_config_access['CAREERS_candidateJoiningDate'].label|| 'Joining Date' | translate">
                          </tm-date-picker>
                        </div>

                        <div class=" p-2 offer-letter-view-btn">
                          <p (click)="termsConditions()" *ngIf="!disable_action" class="text-center">
                            <input id="field_terms" type="checkbox" [(ngModel)]="terms_conditions" name="terms">
                            <label class="ml-2 d-inline" for="field_terms">
                              {{offer_details.termsText}}
                            </label>
                          </p>

                          <ng-container *ngIf="!offer_details?.manualAcceptance">
                            <div *ngIf="!disable_action" style="text-align: center">
                              <ng-container *ngIf="sign_upload_type == 1 || !sign_upload_type;">
                                <app-digital-signature form_control="signature" [form_group]="digital_signature_form"
                                  [label]="'OFFER.signature' | translate"
                                  [placeholder]="'OFFER.signature_placeholder' | translate" width="100%" [height]="150">
                                </app-digital-signature>
                              </ng-container>
                              <ng-container *ngIf="sign_upload_type == 2;">
                                <app-file-upload-and-preview form_control="signature"
                                  [form_group]="digital_signature_form" [label]="'OFFER.signature' | translate"
                                  [placeholder]="'OFFER.signature_upload' | translate" width="100%" [height]="150">
                                </app-file-upload-and-preview>
                              </ng-container>

                              <div class="link mb-2 text-center" (click)="toggleSignatureType()">
                                {{
                                (sign_upload_type && sign_upload_type == 2 ?'OFFER.digital_sign' :
                                'OFFER.upload_sign')
                                | translate
                                }}
                              </div>
                            </div>

                            <div *ngIf="disable_action" style="text-align: center">

                              <app-file-upload-and-preview form_control="signature"
                                [form_group]="digital_signature_form" [label]="'OFFER.signature' | translate"
                                [placeholder]="'OFFER.signature_upload' | translate" width="100%" [height]="150"
                                [disabled]="disable_action">
                              </app-file-upload-and-preview>


                              <div class="link mb-2 text-center" (click)="toggleSignatureType()"
                                *ngIf="!disable_action">
                                {{
                                (sign_upload_type && sign_upload_type == 2 ?'OFFER.digital_sign' :
                                'OFFER.upload_sign')
                                |translate
                                }}
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="offer_details?.manualAcceptance">
                            <tm-files-v2 [form_group]="digital_signature_form" [form_control]="'signedAttachLetter'"
                              (validStatus)="uploadedStatus($event)" [required]="1"
                              [label]="field_config_access['CAREERS_signedAttachLetter'].label ||'Attachments'|translate"
                              [result]="digital_signature_form.value.signedAttachLetter"></tm-files-v2>
                          </ng-container>

                          <div class="text-center action-taken" *ngIf="disable_action && offer_details">
                            <!-- <span *ngIf="!(offer_details.offerAcceptance)">
                              An action was taken
                              <span *ngIf="offer_details.offer_accepted_datetime">
                                on
                                {{offer_details.offer_accepted_datetime}}
                              </span>
                            </span> -->
                            <span>
                              You have
                              <!-- <span *ngIf="offer_details.offerAcceptance == 1">
                                accepted
                              </span>
                              <span *ngIf="offer_details.offerAcceptance == 2">
                                declined
                              </span> -->
                              <span *ngIf="offer_details.actionTakenText">
                                {{offer_details.actionTakenText}}
                              </span>
                              the offer
                              <span *ngIf="offer_details.offerAcceptedDate">
                                on
                                {{offer_details.offerAcceptedDate | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'}}
                              </span>

                              <span *ngIf="offer_details.offerIP">
                                on the device having IP {{offer_details.offerIP}}
                              </span>
                            </span>

                          </div>

                          <div *ngIf="!disable_action" class="text-center">

                            <div class="form-group">
                              <div class="tm-captcha" #recaptcha id="tm-recaptcha"></div>
                            </div>

                            <button type="button" class="btn btn-sm js-btn-cancel mx-1"
                              (click)="submitOfferAcceptance(2)" *ngIf="!offer_details.disableDeclineAction">
                              {{'BTN.decline' | translate}}
                            </button>
                            <button class="btn btn-sm js-btn-save mx-1" type="button"
                              (click)="submitOfferAcceptance(1)">
                              {{'BTN.accept' | translate}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="type==6">
          <offer-onb-field-details *ngIf="form_details" [disabled_fields]="disable_action" [form_details]="form_details"
            [type]="6" [verificationObj]="verificationObj" [disable_button]="disable_action"
            [afterSaveAction]="submitOfferAcceptanceApiCallRef">
          </offer-onb-field-details>
        </ng-container>
      </div>
      <div *ngIf="!offer_details && !type" class="err_message">
        {{error_message}}
      </div>
    </div>
  </section>
</div>
